export default "__VITE_ASSET__CwOgENRp__"